import axios from 'axios'
import store from '@/store'
import appConfig from '@/config/app.config'
import { deserialize } from "deserialize-json-api"
const $http = axios.create({
    baseURL: `${appConfig.API_BASE_URL}`,
    withCredentials: true,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    }
});

$http.interceptors.response.use(async function(response){
    response.data = deserialize(response.data);
    return response
    
})

$http.interceptors.request.use(async function (xhrConfig) {
    await store.dispatch('session/refresh')
    console.log("TOKEN:: ",store.getters['session/currentToken'])
    xhrConfig.headers["Authorization"] = store.getters['session/currentToken'];
    return xhrConfig;
});

$http.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const data = error.response || error.request;
        switch (data.status) {
            case 401:
                
                break;
            case 500:
                
                break;
            case 403:
                
                break;
        }
        return Promise.reject(error);
    });

export default $http;
